import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import axiosInstance from "../../Service/axiosInstance";
import { Button } from "@mui/material";

function TypeOffres() {
  const navigate = useNavigate();
  const { idTypeOffre } = useParams(); // Récupérer l'ID du type d'offre depuis l'URL
  const [packages, setPackages] = useState([]);

  useEffect(() => {
    if (idTypeOffre) {
      axiosInstance
        .get(`/yourtravelshop/typeOffre/${idTypeOffre}`)
        .then((response) => {
             setPackages(response.data);
        })
        .catch((error) => {
          console.error("Erreur lors de la récupération des packages :", error);
        });
    }
  }, [idTypeOffre]);

  return (
    <div>
      <div className="home">
        <div
          className="home_background"
          style={{
            backgroundImage: `url(${process.env.PUBLIC_URL}/assets/images/Ofer.jpeg)`,
            backgroundSize: "cover",
            backgroundPosition: "center",
          }}
        >
          <div className="home_content">
            <div className="home_title">Nos Offres</div>
          </div>
        </div>
      </div>
      <div className="offers">
        <div className="container">
        {packages.length > 0 && packages[0].typeOffre && (
      <h2 style={{
        fontFamily: 'Beyond',
        fontSize: '50px',
        color: '#000000',
      }}>{packages[0].typeOffre.nom}</h2>
    )}
          <div className="row offers_items">
            {packages.map((pkg) => (
              <div className="col-lg-6 offers_col" key={pkg.idPackage}>
                <div className="offers_item">
                  <div className="row">
                    <div className="col-lg-6">
                      <div className="offers_image_container">
                        <div
                          className="offers_image_background"
                          style={{
                            backgroundImage: pkg.prospectusPhoto
                              ? `url(${pkg.prospectusPhoto.stockage})`
                              : "url('default-image.jpg')",
                          }}
                        />
                       <div className="offer_name" style={{ width: 'fit-content'}}>
                          <a href="#">{pkg.nom}</a>
                        </div>
                      </div>
                    </div>
                    <div className="col-lg-6">
                      <div className="offers_content">
                        <div className="offers_price">
                          {pkg.prix} <span> Ariary</span>
                        </div>
                        <p className="offers_text">{pkg.description}</p>
                        <div className="button button_1 offers_button">
                          <Button
                            variant="contained"
                            onClick={() => navigate(`/Package-details/${pkg.idPackage}`)}
                            style={{
                              backgroundColor: "#8a2be2",
                              color: "white",
                              fontWeight: "bold",
                              padding: "10px 20px",
                              borderRadius: "15px",
                            }}
                          >
                            Voir Détails
                          </Button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}

export default TypeOffres;
